import { ContentTypeCondition } from 'govbr.frontend.policy/helpers/SlotConditions';

import BannerServicos from './components/BannerServicos/BannerServicos';

const registerSlotComponents = (config) => {
  // ==================
  // belowHeader
  // ==================

  // Recom
  config.registerSlotComponent({
    slot: 'belowHeader',
    name: 'bannerServicos',
    component: BannerServicos,
    predicates: [ContentTypeCondition(['LRF'])],
  });

  // ==================
  return config;
};

export default registerSlotComponents;
